import { useState, type FormEvent } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { AuthLayout } from "@/components/AuthLayout";
import { Button } from "@/components/ui/Button";
import { Field } from "@/components/ui/Field";
import { useAuth } from "@/contexts/AuthContext";
import { useToast } from "@/components/ui/Toast";

// Réplica de reference/expo-frontend/app/reset-password.tsx: código de 6
// dígitos + nova senha.
export default function ResetPasswordPage() {
  const { resetPassword } = useAuth();
  const { showToast } = useToast();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const email = params.get("email") ?? "";

  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (code.trim().length !== 6) {
      setError("O código deve ter 6 dígitos.");
      return;
    }
    if (password.length < 6) {
      setError("A nova senha deve ter pelo menos 6 caracteres.");
      return;
    }
    setError(null);
    setLoading(true);
    const result = await resetPassword(email, code.trim(), password);
    setLoading(false);
    if (result.error) {
      setError(result.error);
    } else {
      showToast({ type: "success", message: "Senha redefinida! Entre com a nova senha." });
      navigate("/login", { replace: true });
    }
  };

  return (
    <AuthLayout
      title="Nova senha"
      subtitle={
        email
          ? `Digite o código enviado para ${email} e escolha a nova senha.`
          : "Digite o código recebido por e-mail e escolha a nova senha."
      }
    >
      <form onSubmit={onSubmit} className="flex flex-col gap-4.5">
        <Field
          label="Código"
          tone="auth"
          inputMode="numeric"
          autoComplete="one-time-code"
          maxLength={6}
          placeholder="000000"
          value={code}
          onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
          disabled={loading}
        />
        <Field
          label="Nova senha"
          tone="auth"
          type="password"
          autoComplete="new-password"
          placeholder="Mínimo de 6 caracteres"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          disabled={loading}
        />

        {error && (
          <p className="rounded-(--radius-field) bg-destructive/15 px-4 py-3 text-sm text-[#ffb4ad]">
            {error}
          </p>
        )}

        <Button
          type="submit"
          title="Redefinir senha"
          loading={loading}
          className="mt-1"
        />
      </form>

      <div className="mt-6 flex justify-center">
        <Link
          to="/login"
          className="text-[13px] font-bold text-surface-alt-foreground/50"
        >
          Voltar para o login
        </Link>
      </div>
    </AuthLayout>
  );
}
